<script>
	// Stores
	import BonusBetStore from '@/Stores/User/BonusBetStore.js';
	// Components
	import Modal from '@/Components/Modal.svelte';
	import LoadingButton from '@/Components/LoadingButton.svelte';
	import TextInput from '@/Components/TextInput.svelte';
	import TextAreaInput from '@/Components/TextAreaInput.svelte';
	import SelectInput from '@/Components/SelectInput.svelte';
	import Prompt from '@/Components/Prompt.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let open = false;
	export let user;
	export let onSave;

	let sending = false;
	let amount = '';
	let type_id;
	let note = '';
	let errors;

	let checkValue = false;

	$: filterMeta = $BonusBetStore && BonusBetStore.getFilterMeta();

	function confirmClicked() {
		if (!amount || !note) return;
		if (!parseFloat(amount) > 0) {
			errors = {
				balance: ['You must enter a valid number']
			};
			sending = false;
			return;
		}
		let balance = amount * 100;
		sending = true;
		BonusBetStore.saveBonusBet(user.id, { type_id, balance, note })
			.then(() => {
				notify({
					type: 'success',
					title: 'Save Bonus Bet',
					message: `$${amount} Bonus bet saved`,
					timeout: 3
				});
				onSave();
				open = false;
			})
			.catch((e) => {
				errors = e;
				notify({
					type: 'danger',
					title: 'Save Bonus Bet',
					message: (e && e.error && e.error.length > 0 && e.error[0]) || 'Problem saving bonus bet',
					timeout: 5
				});
			})
			.finally(() => {
				sending = false;
			});
	}

	function addBonusToUser() {
		if (!amount || !note) return;
		sending = true;
		if (parseInt(amount) > 999) {
			checkValue = true;
		} else {
			confirmClicked();
		}
	}
</script>

{#if checkValue}
	<Prompt
		bind:open={checkValue}
		title="Confirm promotion value"
		message="The bonus allocation seems high, Are you sure you want to go ahead?"
		onConfirm={confirmClicked}
		on:close={() => {
			sending = false;
		}}
	/>
{/if}

{#if open && filterMeta}
	<Modal on:close={() => (open = false)}>
		<h2 slot="header" class="pt-2 text-xl font-bold text-center">Add Bonus Bets</h2>
		<div class="flex flex-col w-full px-4 pt-2 text-center">
			<SelectInput
				label="Bonus Bet Type"
				className="py-4 w-full"
				name="type_id"
				required={true}
				errors={errors && errors.type_id}
				bind:value={type_id}
			>
				{#each Object.entries(filterMeta) as bonusType}
					<option value={bonusType[0]}>{bonusType[1]}</option>
				{/each}
			</SelectInput>
			<TextInput
				name="amount"
				className="pb-4 w-full"
				type="number"
				bind:value={amount}
				required={true}
				errors={errors && errors.balance}
				placeholder="Amount"
			/>
			<TextAreaInput
				name="note"
				className="pb-4 w-full"
				bind:value={note}
				required={true}
				placeholder="Description ** Client see this **"
			/>
			<LoadingButton on:click={addBonusToUser} loading={sending} className="mb-4 btn btn-primary">Save</LoadingButton>
			<button class="mb-4 btn btn-muted" on:click={() => (open = false)}> Cancel</button>
		</div>
	</Modal>
{/if}
